import { Row, Col } from "antd";


export const LinesList = (props) => {
    const { classes, clsx, data } = props;
    return (
        <div className={clsx(classes.lineRow, classes.margin15t)}>
            <Row className={classes.lineRowHead}>
                <Col span={12}>Product</Col>
                <Col span={4}>Product ID</Col>
                <Col span={4}>Quantity</Col>
                <Col span={4}>Unit</Col>
            </Row>
            {
                data?.length > 0 && data?.map((d, i) => (
                    <Row className={classes.lineRowBody} key={i}>
                        <Col span={12}>{d?.product?.productName || d?.description || ''}</Col>
                        <Col span={4}>{d?.product?.productId || d?.productId || ''}</Col>
                        <Col span={4}>{d?.quantity || '---'}</Col>
                        <Col span={4}>{d?.unit?.name || '---'}</Col>
                    </Row>
                ))
            }
        </div>
    )
}

export const LinesTitle = (props) => {
    const { classes, clsx, data } = props;
    return (
        <div className={clsx(classes.typographyHeader, classes.textclblack, classes.margin20t, classes.bold, classes.fonSize13)}>
            <span>{data?.serialNo} </span>
            <span className={classes.totalQuantity}>
                <span> Total Quantity </span><span>
                    {
                        data?.salesInvoiceItems ?
                            data?.salesInvoiceItems.reduce((a, v) => a = a + v.quantity, 0) : 0
                    }
                </span>
            </span>
        </div>
    )
}